/**
 * HERO-Bezeichnung eines Vorgangs fuer die Anzeige — Spiegel von
 * `core/bezeichnung.projekt_bezeichnung` im Backend.
 *
 * Hausregel: In der Oberflaeche steht IMMER die HERO-Bezeichnung
 * („SAN-534 — Badumbau"), nie eine nackte ID („Projekt #8700484"). Kennt
 * niemand die Bezeichnung, steht eine neutrale Beschriftung da — die Nummer
 * hilft keinem Menschen, den richtigen Vorgang zu erkennen.
 */

/** Neutrale Beschriftung, solange die HERO-Bezeichnung nicht bekannt ist. */
export const VORGANG_OHNE_NAME = "Vorgang in HERO"

// HERO-Auto-Titel: fuehrende (evtl. negative) Zahl, dann Pipe, dann nur noch
// Platzhalterstriche — „-3467 | --, --, --". Technisch ein Titel, fuer einen
// Menschen Muell.
const PLATZHALTER = /^-?\d+\s*\|\s*-{1,2}/

export function titelBereinigen(titel: string | null | undefined): string {
  const roh = (titel || "").trim()
  if (!roh) return ""
  if (!PLATZHALTER.test(roh)) return roh
  const rest = roh.replace(/--/g, "").replace(/\|/g, "").replace(/^[\s\-,]+|[\s\-,]+$/g, "")
  return !rest || /^\d+$/.test(rest) ? "" : rest
}

/**
 * „SAN-534 — Badumbau" wenn Nummer und Titel da sind, sonst das eine von
 * beiden, sonst `null` — NIE die interne ID. Der Aufrufer zeigt bei `null`
 * die neutrale Beschriftung.
 */
export function vorgangBezeichnung(
  nr: string | null | undefined,
  titel: string | null | undefined,
): string | null {
  const n = (nr || "").trim()
  const t = titelBereinigen(titel)
  if (n && t) return `${n} — ${t}`
  return n || t || null
}
